module.exports = __webpack_public_path__ + "static/media/list-alt.959d3e8e.svg";